// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header,
.header-space,
.footer,
.footer-space {
  height: 100px;
}

.header {
  position: fixed;
  top: 0;
}

.header-space {
  margin: 15px 0;
}

.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  text-align: center;
}

table {
  width: 100%;
  height: 100%;
}

@media screen {
  :host {
    display: none;
  }
}
.header-image {
  padding: 0;
  background: #fff !important;
}

.fill-remaining-size {
  flex: 1 1 auto;
}

p {
  color: black !important;
}`, "",{"version":3,"sources":["webpack://./projects/zbs-app/src/app/print-layout/print-layout.component.scss"],"names":[],"mappings":"AAAA;;;;EAIC,aAAA;AACD;;AAEA;EACC,eAAA;EACA,MAAA;AACD;;AAEA;EACC,cAAA;AACD;;AAEA;EACC,eAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,kBAAA;AACD;;AAEA;EACC,WAAA;EACA,YAAA;AACD;;AAEA;EACC;IACC,aAAA;EACA;AACF;AAEA;EACC,UAAA;EACA,2BAAA;AAAD;;AAGA;EACC,cAAA;AAAD;;AAGA;EACC,uBAAA;AAAD","sourcesContent":[".header,\r\n.header-space,\r\n.footer,\r\n.footer-space {\r\n\theight: 100px;\r\n}\r\n\r\n.header {\r\n\tposition: fixed;\r\n\ttop: 0;\r\n}\r\n\r\n.header-space {\r\n\tmargin: 15px 0;\r\n}\r\n\r\n.footer {\r\n\tposition: fixed;\r\n\tbottom: 0;\r\n\tleft: 0;\r\n\twidth: 100%;\r\n\ttext-align: center;\r\n}\r\n\r\ntable {\r\n\twidth: 100%;\r\n\theight: 100%;\r\n}\r\n\r\n@media screen {\r\n\t:host {\r\n\t\tdisplay: none;\r\n\t}\r\n}\r\n\r\n.header-image {\r\n\tpadding: 0;\r\n\tbackground: #fff !important;\r\n}\r\n\r\n.fill-remaining-size {\r\n\tflex: 1 1 auto;\r\n}\r\n\r\np {\r\n\tcolor: black !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
